import api from '@/ts/api';
import tools from '@/ts/tools';
import { WebsocketStore } from '@/ts/ws';
import { defineStore } from 'pinia';

export const Chats = defineStore('chats', {
  state: () => ({  
        // 
  }),
  
  getters: {
      // messages: (state) => (id) => state.list.filter(p => p.asset == id),      
  },
  actions: {
    
    // get chat messages
    async get(id, limit, offset){
      let res = await api.send('admin/chats/get',{id, limit, offset})
      if (res.error) return []
      return res.resp || []
    },
    
    // get chat list
    async list(type, limit, offset){
      let res = await api.send('admin/chats/list',{type, limit, offset})
      if (res.error) return []
      return res.resp || []      
    },


    subscribe(){
      // if (this.handler) return
      // const ws = WebsocketStore()
      // this.handler = this.add
      // let handle = this.handler
      // websocket.subscribe('admin/chats/subscribe', function(res){
      //   let message = res.resp
      //   if (!message) return
      //   handle(message)
      // })  
    },
    
    subscribeChat(chat, handler){
      console.log('chats/subscribe', chat)
      const ws = WebsocketStore()
      ws.handler((res) => {
        let message = res.resp
        if (!message || message.chat != chat) return        
        handler(message)
      })      
    },
  
    
     async send(chat, text, osfiles, reply, user){
      if (!chat) return
      if (!text && !osfiles) return
      
      console.log("chat files", osfiles)
      // upload files
      let files = await this.uploadingFiles(osfiles)
      
      // try to send
      return await api.send('admin/chats/message', {chat, text, reply, files, user})
    },
     
    async sendText(chat, text){
      if (!chat || !text) return          
      return await api.send('admin/chats/message', {chat, text})
    },
     
    // [1,2,3,4,5]
    read(list){      
      api.send('chats/read', {list})
    },

    async uploadingFiles(files, asset) { //[]int
      if (!files) return      
      let result = []
      for (let x = 0; x < files.length; x++) {
        const file = files[x];
         console.log("upload", file)
          let body = await tools.readFileAsBytes(file)
          if (!body) return
          let res = await api.upload.file(body, file.name, asset)
          if (res.error) {
            console.log("upload error", res.error)
            return
          }
          result.push(res.resp.file.id)
          console.log("uploaded", res.resp.file)
      }

      console.log("uploaded files ids", result)
     
      return result
    },


  },
})


/* 

type SupportChat struct {
    User    int    `json:"uid,omitempty"`
    Name    string `json:"name,omitempty"`
    Image   string `json:"image,omitempty"`
    Read    int64  `json:"read,omitempty"`
    Created int64  `json:"created,omitempty"`
    Message string `json:"message,omitempty"`
}
    
*/